import { useEffect, useRef, useState } from 'react';

import type { AplusLayoutDefaultProps } from '../../Layouts/types';
import type { APlusItems } from '../../types';

import { getInitialAplusData } from '../../helper/getInitialAplusData';

export const useAplusData = (
  items: APlusItems,
  onChangeHandler: AplusLayoutDefaultProps['onChangeHandler'],
  triggerOnChangeHandlerOnInit?: AplusLayoutDefaultProps['triggerOnChangeHandlerOnInit'],
) => {
  const [aplusData, setAplusData] = useState(() => getInitialAplusData(items));
  const initialTrigger = useRef(!!triggerOnChangeHandlerOnInit);

  useEffect(() => {
    if (initialTrigger.current) {
      onChangeHandler(aplusData);
      initialTrigger.current = false;
    }
  }, [onChangeHandler, aplusData]);

  const handleItemChange = (uuid: string, value?: number) => {
    const newAplusData = new Map(aplusData);
    const itemData = newAplusData.get(uuid);
    if (itemData) {
      itemData.selected = !itemData.selected;
      itemData.value = value;
      setAplusData(newAplusData);
      onChangeHandler(newAplusData);
    }
  };

  return {
    aplusData,
    handleItemChange,
  };
};
